/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignPostListResponseSchema,
  campaignPostSortSchema,
} from '../campaign-schema';
import { CAMPAIGN_POST_SORT } from '../campaign-constants';

export const listCampaignPostsPathSchema = z.object({ campaignId: z.string() });

export const listCampaignPostsQuerySchema = z.object({
  sort: campaignPostSortSchema.default(CAMPAIGN_POST_SORT.POSTED_AT_DESC),
  page: z.number().int().default(1),
  limit: z.number().int().default(20),
});

export const listCampaignPostsOperationResponseSchema =
  campaignPostListResponseSchema;

export type ListCampaignPostsInput = {
  path: z.input<typeof listCampaignPostsPathSchema>;
  query?: z.input<typeof listCampaignPostsQuerySchema>;
  signal?: AbortSignal;
};

export async function listCampaignPosts({
  path,
  query,
  signal,
}: ListCampaignPostsInput): Promise<
  z.infer<typeof listCampaignPostsOperationResponseSchema>
> {
  const parsedPath = listCampaignPostsPathSchema.parse(path);
  const parsedQuery = listCampaignPostsQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/posts`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return listCampaignPostsOperationResponseSchema.parse(await response.json());
}
